import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import apolloProvider from "./vue-apollo";

Vue.config.productionTip = false;

// progressive web app
import "@/registerServiceWorker";

// initialize dependencies
import "@/packages/fontawesome";
import "@/packages/touch-events";
import "@/packages/line-clamp";
import "@/packages/validate";
import "@/packages/lazyload";
import "@/packages/checkbox";
import "@/packages/portal";
import "@/packages/slider";

// initialize custom global components
import "@/components";
import "@/filters";

// initialize the state
// - fetch setup
import "@/init";

// configure auto fetch page content
import "@/router/middleware";

new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount("#app");
